import { Pipe, PipeTransform } from '@angular/core';
import { Purchase } from '@galaxy/billing';
import { isAfter } from 'date-fns';

// Evaluates whether a purchase is currently paused in dunning
@Pipe({
  name: 'isDunningPaused',
  standalone: true,
})
export class IsDunningPausedPipe implements PipeTransform {
  transform(purchase: Purchase): boolean {
    return purchase?.pauseDunningUntil && isAfter(purchase.pauseDunningUntil, new Date());
  }
}
